import { nanoid } from 'nanoid';

export function makeId(typeName?: string | undefined): string {
  return `${typeName ? typeName : 'ANONYMOUS_TYPE'}_${encodeURIComponent(nanoid())}`;
}
